import { ClientSharedValues } from "./runtimeConfig.shared";
export const ClientDefaultValues = {
    ...ClientSharedValues,
    runtime: "browser",
};
